exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popover.el-popper.dt-popover{-webkit-transition:all .3s linear;transition:all .3s linear}.el-popover.el-popper.dt-popover.menu{border-radius:0}.el-popover.el-popper.dt-popover.drop-down.menu{border-bottom-left-radius:4px;border-bottom-right-radius:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ec34f774","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/ctrl/DtPopover.vue
// module id = 2138
// module chunks = 0